// extracted by mini-css-extract-plugin
module.exports = {"hide":"BookInfo_hide__1vrpU","rtBookInfo":"BookInfo_rtBookInfo__Ur4CL","rtInfoCard":"BookInfo_rtInfoCard__kgAwd","title":"BookInfo_title__14SKC","text":"BookInfo_text__1MKh6"};